import React, { useState, useEffect } from "react";
import TextBlockEdit from "./TextBlockEdit";
import InputBlockEdit from "./InputBlockEdit";
import HeaderBlockEdit from "./HeaderBlockEdit";
import FooterBlockEdit from "./FooterBlockEdit";
import InputText from "../../../../Shared/UiKit/InputText";
import DividerBlockEdit from "./DividerBlockEdit";
import {toast} from "react-toastify";
import Tooltip from "../../../../Shared/Tootip";
import GroupBlockEdit from "./GroupBlockEdit";
import ImageBlockEdit from "./ImageBlockEdit";

const BlockEdit = (props) => {
    const {
        block: initialBlock,
        onExpended,
        onChange: onChangeProp,
        onDelete,
        dragging,
        expended,
        isHovered,
    } = props;

    const [showOptions, setShowOptions] = useState(false);
    const [block, setBlock] = useState(initialBlock);

    // Mise à jour du bloc si les props changent
    useEffect(() => {
        setBlock(initialBlock);
    }, [initialBlock]);

    const init = () => {
        const types = {
            HEADER: {
                type: "En-tête",
                name: block.name || "",
                render: (
                    <HeaderBlockEdit
                        data={block.data}
                        onChange={(data) => onChange(data)}
                    />
                ),
            },
            INPUT: {
                type: "Contenu éditable",
                name: block.name || "",
                render: (
                    <InputBlockEdit
                        inputs={block.data}
                        onChange={(data) => onChange(data)}
                    />
                ),
            },
            TEXT: {
                type: "Texte",
                name: block.name || "",
                render: (
                    <TextBlockEdit
                        data={block.data}
                        onChange={(data) => onChange(data)}
                    />
                ),
            },
            FOOTER: {
                type: "Pied de page",
                name: block.name || "",
                render: (
                    <FooterBlockEdit
                        data={block.data}
                        onChange={(data) => onChange(data)}
                    />
                ),
            },
            DIVIDER: {
                type: "Séparateur",
                render: (
                    <DividerBlockEdit
                        id={block.id}
                        data={block.data}
                        onChange={(data) => onChange(data)}
                    />
                ),
            },
            GROUP: {
                type: "Groupe",
                name: block.name || "",
                render: (
                    <GroupBlockEdit
                        id={block.id}
                        data={block.data}
                        onChange={(data) => onChange(data)}
                    />
                ),
            },
            IMAGE: {
                type: "Image",
                name: block.name || "",
                render: (
                    <ImageBlockEdit
                        id={block.id}
                        data={block.data}
                        onChange={(data) => onChange(data)}
                    />
                ),
            },
        };
        return types[block.type] || null;
    };

    const toggle = (e) => {
        e.preventDefault();
        onExpended(block);
    };

    const changeName = (name) => {
        const updatedBlock = { ...block, name };
        setBlock(updatedBlock);
        onChangeProp(updatedBlock);
    };

    const onChange = (data) => {
        const updatedBlock = { ...block, data };
        setBlock(updatedBlock);
        onChangeProp(updatedBlock);
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDelete(block);
    };

    const toClipboard = (e) => {
        e.stopPropagation();
        localStorage.setItem("COPIED_BLOCK", JSON.stringify(block));
        toast.success("Élément copié avec succès.");
    };

    const color = () => {
        if (block.type === "DIVIDER") return "grey lighten-2";
        if (dragging && block.type === "GROUP") return "blue lighten-5";
        return "white";
    };

    const currentBlock = init();
    if (!currentBlock) return null;

    return (
        <div className={`${color()} z-depth-1`}
            style={{ width: "100%" }}
            onMouseEnter={() => isHovered(true)}
            onMouseLeave={() => isHovered(false)}
        >
            {/* HEAD */}
            <div style={{ display: "flex" }}>
                <a href="#/custom_reports" style={{ width: "100%" }}
                    onClick={toggle}
                    onMouseEnter={() => setShowOptions(true)}
                    onMouseLeave={() => setShowOptions(false)}
                >
                    <div
                        className="black-text valign-wrapper"
                        style={{ display: "flex", padding: "10px 20px" }}
                    >
                        <div style={{ margin: 0 }}>
                            <h5 style={{ margin: "1vh 0" }}>
                                {currentBlock.name || currentBlock.type}
                            </h5>
                            <h6
                                className={`${expended ? "hide" : ""}`}
                                style={{ paddingLeft: "1vw", color: "#6a6a6a" }}
                            >
                                {currentBlock.name ? currentBlock.type : ""}
                            </h6>
                        </div>
                        <div style={{ marginLeft: "auto" }}>
                            <div className="valign-wrapper">
                                <div id="hoverable">
                                    <Tooltip
                                        id={`copy_block_${block.id}`}
                                        text="Copier l'élément."
                                    >
                                        <div
                                            onClick={toClipboard}
                                            className={`btn-floating btn-small z-depth-0 transparent ${
                                                showOptions ? "" : "hide"
                                            }`}
                                        >
                                            <i className="material-icons green-text">
                                                content_copy
                                            </i>
                                        </div>
                                    </Tooltip>
                                </div>
                                <div id="hoverable">
                                    <Tooltip
                                        id={`delete_block_${block.id}`}
                                        text="Supprimer l'élément."
                                    >
                                        <div
                                            onClick={handleDelete}
                                            className={`btn-floating btn-small z-depth-0 transparent ${
                                                showOptions ? "" : "hide"
                                            }`}
                                        >
                                            <i className="material-icons red-text">
                                                delete
                                            </i>
                                        </div>
                                    </Tooltip>
                                </div>
                                <div className="btn-floating btn-small waves-light z-depth-0 transparent">
                                    <i
                                        className="material-icons grey-text"
                                        style={{
                                            transform: `rotate(${
                                                expended ? "90deg" : "0"
                                            })`,
                                            transition: "all 0.5s",
                                        }}
                                    >
                                        chevron_right
                                    </i>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            {expended && (
                <div>
                    <div
                        className={`${
                            block.type === "DIVIDER" ? "hide" : ""
                        }`}
                        style={{ padding: "0 10px 2vh 10px" }}
                    >
                        Nom
                        <InputText
                            defaultValue={block.name}
                            width="100%"
                            onChange={(event) =>
                                changeName(event.target.value)
                            }
                        />
                    </div>
                    <div
                        className="black-text"
                        style={{ display: "flex", padding: "0 10px 2vh 10px" }}
                    >
                        {currentBlock.render}
                    </div>
                </div>
            )}
        </div>
    );
};

BlockEdit.defaultProps = {
    block: {},
};

export default BlockEdit;
